export default [
    { region: "INT", name: "Afghanistan", code: "AF" },
    { region: "INT", name: "Åland Islands", code: "AX" },
    { region: "INT", name: "Albania", code: "AL" },
    { region: "INT", name: "Algeria", code: "DZ" },
    { region: "INT", name: "American Samoa", code: "AS" },
    { region: "INT", name: "Andorra", code: "AD" },
    { region: "INT", name: "Angola", code: "AO" },
    { region: "INT", name: "Anguilla", code: "AI" },
    { region: "INT", name: "Antarctica", code: "AQ" },
    { region: "INT", name: "Antigua and Barbuda", code: "AG" },
    { region: "INT", name: "Argentina", code: "AR" },
    { region: "INT", name: "Armenia", code: "AM" },
    { region: "INT", name: "Aruba", code: "AW" },
    { region: "AUS", name: "Australia", code: "AU" },
    { region: "EUR", name: "Austria", code: "AT" },
    { region: "INT", name: "Azerbaijan", code: "AZ" },
    { region: "INT", name: "Bahamas", code: "BS" },
    { region: "INT", name: "Bahrain", code: "BH" },
    { region: "INT", name: "Bangladesh", code: "BD" },
    { region: "INT", name: "Barbados", code: "BB" },
    { region: "INT", name: "Belarus", code: "BY" },
    { region: "EUR", name: "Belgium", code: "BE" },
    { region: "INT", name: "Belize", code: "BZ" },
    { region: "INT", name: "Benin", code: "BJ" },
    { region: "INT", name: "Bermuda", code: "BM" },
    { region: "INT", name: "Bhutan", code: "BT" },
    { region: "INT", name: "Bolivia", code: "BO" },
    { region: "INT", name: "Bosnia and Herzegovina", code: "BA" },
    { region: "INT", name: "Botswana", code: "BW" },
    { region: "INT", name: "Bouvet Island", code: "BV" },
    { region: "INT", name: "Brazil", code: "BR" },
    { region: "INT", name: "British Indian Ocean Territory", code: "IO" },
    { region: "INT", name: "Brunei Darussalam", code: "BN" },
    { region: "EUR", name: "Bulgaria", code: "BG" },
    { region: "INT", name: "Burkina Faso", code: "BF" },
    { region: "INT", name: "Burundi", code: "BI" },
    { region: "INT", name: "Cambodia", code: "KH" },
    { region: "INT", name: "Cameroon", code: "CM" },
    { region: "CAN", name: "Canada", code: "CA" },
    { region: "INT", name: "Cape Verde", code: "CV" },
    { region: "INT", name: "Cayman Islands", code: "KY" },
    { region: "INT", name: "Central African Republic", code: "CF" },
    { region: "INT", name: "Chad", code: "TD" },
    { region: "INT", name: "Chile", code: "CL" },
    { region: "INT", name: "China", code: "CN" },
    { region: "INT", name: "Christmas Island", code: "CX" },
    { region: "INT", name: "Cocos (Keeling) Islands", code: "CC" },
    { region: "INT", name: "Colombia", code: "CO" },
    { region: "INT", name: "Comoros", code: "KM" },
    { region: "INT", name: "Congo", code: "CG" },
    { region: "INT", name: "Congo, The Democratic Republic of the", code: "CD" },
    { region: "INT", name: "Cook Islands", code: "CK" },
    { region: "INT", name: "Costa Rica", code: "CR" },
    { region: "INT", name: "Cote D'Ivoire", code: "CI" },
    { region: "EUR", name: "Croatia", code: "HR" },
    { region: "INT", name: "Cuba", code: "CU" },
    { region: "INT", name: "Cyprus", code: "CY" },
    { region: "EUR", name: "Czech Republic", code: "CZ" },
    { region: "EUR", name: "Denmark", code: "DK" },
    { region: "INT", name: "Djibouti", code: "DJ" },
    { region: "INT", name: "Dominica", code: "DM" },
    { region: "INT", name: "Dominican Republic", code: "DO" },
    { region: "INT", name: "Ecuador", code: "EC" },
    { region: "INT", name: "Egypt", code: "EG" },
    { region: "INT", name: "El Salvador", code: "SV" },
    { region: "INT", name: "Equatorial Guinea", code: "GQ" },
    { region: "INT", name: "Eritrea", code: "ER" },
    { region: "EUR", name: "Estonia", code: "EE" },
    { region: "INT", name: "Ethiopia", code: "ET" },
    { region: "INT", name: "Falkland Islands (Malvinas)", code: "FK" },
    { region: "INT", name: "Faroe Islands", code: "FO" },
    { region: "INT", name: "Fiji", code: "FJ" },
    { region: "EUR", name: "Finland", code: "FI" },
    { region: "EUR", name: "France", code: "FR" },
    { region: "INT", name: "French Guiana", code: "GF" },
    { region: "INT", name: "French Polynesia", code: "PF" },
    { region: "INT", name: "French Southern Territories", code: "TF" },
    { region: "INT", name: "Gabon", code: "GA" },
    { region: "INT", name: "Gambia", code: "GM" },
    { region: "INT", name: "Georgia", code: "GE" },
    { region: "EUR", name: "Germany", code: "DE" },
    { region: "INT", name: "Ghana", code: "GH" },
    { region: "INT", name: "Gibraltar", code: "GI" },
    { region: "EUR", name: "Greece", code: "GR" },
    { region: "INT", name: "Greenland", code: "GL" },
    { region: "INT", name: "Grenada", code: "GD" },
    { region: "INT", name: "Guadeloupe", code: "GP" },
    { region: "INT", name: "Guam", code: "GU" },
    { region: "INT", name: "Guatemala", code: "GT" },
    { region: "INT", name: "Guernsey", code: "GG" },
    { region: "INT", name: "Guinea", code: "GN" },
    { region: "INT", name: "Guinea-Bissau", code: "GW" },
    { region: "INT", name: "Guyana", code: "GY" },
    { region: "INT", name: "Haiti", code: "HT" },
    { region: "INT", name: "Heard Island and Mcdonald Islands", code: "HM" },
    { region: "INT", name: "Holy See (Vatican City State)", code: "VA" },
    { region: "INT", name: "Honduras", code: "HN" },
    { region: "INT", name: "Hong Kong", code: "HK" },
    { region: "EUR", name: "Hungary", code: "HU" },
    { region: "INT", name: "Iceland", code: "IS" },
    { region: "INT", name: "India", code: "IN" },
    { region: "INT", name: "Indonesia", code: "ID" },
    { region: "INT", name: "Iran, Islamic Republic Of", code: "IR" },
    { region: "INT", name: "Iraq", code: "IQ" },
    { region: "EUR", name: "Ireland", code: "IE" },
    { region: "GBR", name: "Isle of Man", code: "IM" },
    { region: "INT", name: "Israel", code: "IL" },
    { region: "EUR", name: "Italy", code: "IT" },
    { region: "INT", name: "Jamaica", code: "JM" },
    { region: "INT", name: "Japan", code: "JP" },
    { region: "INT", name: "Jersey", code: "JE" },
    { region: "INT", name: "Jordan", code: "JO" },
    { region: "INT", name: "Kazakhstan", code: "KZ" },
    { region: "INT", name: "Kenya", code: "KE" },
    { region: "INT", name: "Kiribati", code: "KI" },
    { region: "INT", name: "Korea, Democratic People'S Republic of", code: "KP" },
    { region: "INT", name: "Korea, Republic of", code: "KR" },
    { region: "INT", name: "Kosovo", code: "XK" },
    { region: "INT", name: "Kuwait", code: "KW" },
    { region: "INT", name: "Kyrgyzstan", code: "KG" },
    { region: "INT", name: "Lao People'S Democratic Republic", code: "LA" },
    { region: "EUR", name: "Latvia", code: "LV" },
    { region: "INT", name: "Lebanon", code: "LB" },
    { region: "INT", name: "Lesotho", code: "LS" },
    { region: "INT", name: "Liberia", code: "LR" },
    { region: "INT", name: "Libyan Arab Jamahiriya", code: "LY" },
    { region: "INT", name: "Liechtenstein", code: "LI" },
    { region: "EUR", name: "Lithuania", code: "LT" },
    { region: "EUR", name: "Luxembourg", code: "LU" },
    { region: "INT", name: "Macao", code: "MO" },
    { region: "INT", name: "Macedonia, The Former Yugoslav Republic of", code: "MK" },
    { region: "INT", name: "Madagascar", code: "MG" },
    { region: "INT", name: "Malawi", code: "MW" },
    { region: "INT", name: "Malaysia", code: "MY" },
    { region: "INT", name: "Maldives", code: "MV" },
    { region: "INT", name: "Mali", code: "ML" },
    { region: "EUR", name: "Malta", code: "MT" },
    { region: "INT", name: "Marshall Islands", code: "MH" },
    { region: "INT", name: "Martinique", code: "MQ" },
    { region: "INT", name: "Mauritania", code: "MR" },
    { region: "INT", name: "Mauritius", code: "MU" },
    { region: "INT", name: "Mayotte", code: "YT" },
    { region: "INT", name: "Mexico", code: "MX" },
    { region: "INT", name: "Micronesia, Federated States of", code: "FM" },
    { region: "INT", name: "Moldova, Republic of", code: "MD" },
    { region: "INT", name: "Monaco", code: "MC" },
    { region: "INT", name: "Mongolia", code: "MN" },
    { region: "EUR", name: "Montenegro", code: "ME" },
    { region: "INT", name: "Montserrat", code: "MS" },
    { region: "INT", name: "Morocco", code: "MA" },
    { region: "INT", name: "Mozambique", code: "MZ" },
    { region: "INT", name: "Myanmar", code: "MM" },
    { region: "INT", name: "Namibia", code: "NA" },
    { region: "INT", name: "Nauru", code: "NR" },
    { region: "INT", name: "Nepal", code: "NP" },
    { region: "EUR", name: "Netherlands", code: "NL" },
    { region: "INT", name: "Netherlands Antilles", code: "AN" },
    { region: "INT", name: "New Caledonia", code: "NC" },
    { region: "NZL", name: "New Zealand", code: "NZ" },
    { region: "INT", name: "Nicaragua", code: "NI" },
    { region: "INT", name: "Niger", code: "NE" },
    { region: "INT", name: "Nigeria", code: "NG" },
    { region: "INT", name: "Niue", code: "NU" },
    { region: "INT", name: "Norfolk Island", code: "NF" },
    { region: "INT", name: "Northern Mariana Islands", code: "MP" },
    { region: "INT", name: "Norway", code: "NO" },
    { region: "INT", name: "Oman", code: "OM" },
    { region: "INT", name: "Pakistan", code: "PK" },
    { region: "INT", name: "Palau", code: "PW" },
    { region: "INT", name: "Palestinian Territory, Occupied", code: "PS" },
    { region: "INT", name: "Panama", code: "PA" },
    { region: "INT", name: "Papua New Guinea", code: "PG" },
    { region: "INT", name: "Paraguay", code: "PY" },
    { region: "INT", name: "Peru", code: "PE" },
    { region: "INT", name: "Philippines", code: "PH" },
    { region: "INT", name: "Pitcairn", code: "PN" },
    { region: "EUR", name: "Poland", code: "PL" },
    { region: "EUR", name: "Portugal", code: "PT" },
    { region: "INT", name: "Puerto Rico", code: "PR" },
    { region: "INT", name: "Qatar", code: "QA" },
    { region: "INT", name: "Reunion", code: "RE" },
    { region: "EUR", name: "Romania", code: "RO" },
    { region: "INT", name: "Russian Federation", code: "RU" },
    { region: "INT", name: "Rwanda", code: "RW" },
    { region: "INT", name: "Saint Helena", code: "SH" },
    { region: "INT", name: "Saint Kitts and Nevis", code: "KN" },
    { region: "INT", name: "Saint Lucia", code: "LC" },
    { region: "INT", name: "Saint Pierre and Miquelon", code: "PM" },
    { region: "INT", name: "Saint Vincent and the Grenadines", code: "VC" },
    { region: "INT", name: "Samoa", code: "WS" },
    { region: "INT", name: "San Marino", code: "SM" },
    { region: "INT", name: "Sao Tome and Principe", code: "ST" },
    { region: "INT", name: "Saudi Arabia", code: "SA" },
    { region: "INT", name: "Senegal", code: "SN" },
    { region: "EUR", name: "Serbia", code: "RS" },
    { region: "INT", name: "Serbia and Montenegro", code: "CS" },
    { region: "INT", name: "Seychelles", code: "SC" },
    { region: "INT", name: "Sierra Leone", code: "SL" },
    { region: "INT", name: "Singapore", code: "SG" },
    { region: "EUR", name: "Slovakia", code: "SK" },
    { region: "EUR", name: "Slovenia", code: "SI" },
    { region: "INT", name: "Solomon Islands", code: "SB" },
    { region: "INT", name: "Somalia", code: "SO" },
    { region: "INT", name: "South Africa", code: "ZA" },
    { region: "INT", name: "South Georgia and the South Sandwich Islands", code: "GS" },
    { region: "EUR", name: "Spain", code: "ES" },
    { region: "INT", name: "Sri Lanka", code: "LK" },
    { region: "INT", name: "Sudan", code: "SD" },
    { region: "INT", name: "Suriname", code: "SR" },
    { region: "INT", name: "Svalbard and Jan Mayen", code: "SJ" },
    { region: "INT", name: "Swaziland", code: "SZ" },
    { region: "EUR", name: "Sweden", code: "SE" },
    { region: "INT", name: "Switzerland", code: "CH" },
    { region: "INT", name: "Syrian Arab Republic", code: "SY" },
    { region: "INT", name: "Taiwan, Province of China", code: "TW" },
    { region: "INT", name: "Tajikistan", code: "TJ" },
    { region: "INT", name: "Tanzania, United Republic of", code: "TZ" },
    { region: "INT", name: "Thailand", code: "TH" },
    { region: "INT", name: "Timor-Leste", code: "TL" },
    { region: "INT", name: "Togo", code: "TG" },
    { region: "INT", name: "Tokelau", code: "TK" },
    { region: "INT", name: "Tonga", code: "TO" },
    { region: "INT", name: "Trinidad and Tobago", code: "TT" },
    { region: "INT", name: "Tunisia", code: "TN" },
    { region: "INT", name: "Turkey", code: "TR" },
    { region: "INT", name: "Turkmenistan", code: "TM" },
    { region: "INT", name: "Turks and Caicos Islands", code: "TC" },
    { region: "INT", name: "Tuvalu", code: "TV" },
    { region: "INT", name: "Uganda", code: "UG" },
    { region: "INT", name: "Ukraine", code: "UA" },
    { region: "INT", name: "United Arab Emirates", code: "AE" },
    {
        region: "GBR",
        name: "United Kingdom",
        code: "GB",
        alias: [
            { name: "UK", code: "GB" },
            { name: "England", code: "GB" },
            { name: "Great Britain", code: "GB" },
            { name: "Scotland", code: "GB" },
            { name: "Wales", code: "GB" },
            { name: "Northern Ireland", code: "GB" },
        ],
    },
    {
        region: "USA",
        name: "United States of America",
        code: "US",
        alias: [{ name: "USA", code: "US" }],
    },
    { region: "INT", name: "United States Minor Outlying Islands", code: "UM" },
    { region: "INT", name: "Uruguay", code: "UY" },
    { region: "INT", name: "Uzbekistan", code: "UZ" },
    { region: "INT", name: "Vanuatu", code: "VU" },
    { region: "INT", name: "Venezuela", code: "VE" },
    { region: "INT", name: "Vietnam", code: "VN" },
    { region: "INT", name: "Virgin Islands, British", code: "VG" },
    { region: "INT", name: "Virgin Islands, U.S.", code: "VI" },
    { region: "INT", name: "Wallis and Futuna", code: "WF" },
    { region: "INT", name: "Western Sahara", code: "EH" },
    { region: "INT", name: "Yemen", code: "YE" },
    { region: "INT", name: "Zambia", code: "ZM" },
    { region: "INT", name: "Zimbabwe", code: "ZW" },
];
